import { FaqLinkTile } from "@ui/components/faqs/faq-link-tile";
import { FaqQuestion } from "@ui/components/faqs/types";
import React, { FC } from "react";
import { FaqDropdownTile } from "./faq-dropdown-tile";

interface Props {
    className?: string;
    isLink?: boolean;
    items: FaqQuestion[];
}

export const Faqs: FC<Props> = ({ className, isLink = false, items }) => (
    <div className={`divide-y-2 divide-uxfLightGray border-b-2 border-uxfLightGray ${className || ""}`}>
        {items.map((item) =>
            isLink ? <FaqLinkTile key={item.id} {...item} /> : <FaqDropdownTile key={item.id} {...item} />,
        )}
    </div>
);
